export default __webpack_public_path__ + "static/media/image-20240111-110923.6aa4a08d.png";